import script from "./SearchPicTemp.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchPicTemp.vue?vue&type=script&setup=true&lang=js"

import "./SearchPicTemp.vue?vue&type=style&index=0&id=99961eee&lang=scss&scoped=true"

import exportComponent from "E:\\Projects\\big-screen\\ori\\nnu-data-viewer-1204\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99961eee"]])

export default __exports__